export default [
  {
    path: '/tools/forms/create',
    name: 'tools-forms-create',
    component: () => import('@/views/tools/forms/CreateForm.vue'),
    meta: {
      resource: 'Tools',
      pageTitle: 'Create Form',
      breadcrumb: [
        {
          text: 'Tools',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Forms',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Create Form',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tools/forms',
    name: 'tools-forms-list',
    component: () => import('@/views/tools/forms/FormsList.vue'),
    meta: {
      resource: 'Tools',
      pageTitle: 'Forms',
      breadcrumb: [
        {
          text: 'Tools',
          active: false,
        },
        {
          text: 'Forms',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tools/forms/edit/:id',
    name: 'tools-forms-edit',
    component: () => import('@/views/tools/forms/CreateForm.vue'),
    meta: {
      resource: 'Tools',
      pageTitle: 'Edit Form',
      breadcrumb: [
        {
          text: 'Tools',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Forms',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Edit Form',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tools/forms/view/:id',
    name: 'tools-forms-view',
    component: () => import('@/views/tools/forms/ViewForm.vue'),
    meta: {
      resource: 'Tools',
      pageTitle: 'View Form',
      breadcrumb: [
        {
          text: 'Tools',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Forms',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'View Form',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tools/forms/view-responses/:id',
    name: 'tools-forms-view-responses',
    component: () => import('@/views/tools/forms/ViewResponses.vue'),
    meta: {
      resource: 'Tools',
      pageTitle: 'View Responses',
      breadcrumb: [
        {
          text: 'Tools',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Forms',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'View Responses',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tools/forms/fill/:id',
    name: 'tools-forms-fill',
    component: () => import('@/views/tools/forms/FillForm.vue'),
    meta: {
      resource: 'Tools',
      pageTitle: 'Fill Form',
      breadcrumb: [
        {
          text: 'Tools',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Forms',
          to: { name: 'tools-forms-list' }
        },
        {
          text: 'Fill Form',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tools/forms/view-submission/:id',
    name: 'tools-forms-view-submission',
    component: () => import('@/views/tools/forms/ViewSubmission.vue'),
    meta: {
      resource: 'Tools',
      pageTitle: 'My Submission',
      breadcrumb: [
        { text: 'Tools', to: { name: 'tools-forms-list' } },
        { text: 'Forms', to: { name: 'tools-forms-list' } },
        { text: 'My Submission', active: true },
      ],
    },
  },
  {
    path: '/tools/micro-tools/employee-survey',
    name: 'employee-survey',
    component: () => import('@/views/tools/micro-tools/EmployeeSurvey.vue'),
    meta: {
      resource: 'employee-survey',
      pageTitle: 'Employee Satisfaction Survey',
      breadcrumb: [
        {
          text: 'Tools',
          to: { name: 'employee-survey' }
        },
      ],
      action: 'read'
    },
  },
  {
    path: '/tools/micro-tools/employee-survey-responses',
    name: 'employee-survey-responses',
    component: () => import('@/views/tools/micro-tools/EmployeeSurveyResponses.vue'),
    meta: {
      resource: 'employee-survey-responses',
      pageTitle: 'Employee Satisfaction Survey Responses',
      breadcrumb: [
        {
          text: 'Tools',
          to: { name: 'employee-survey-responses' }
        },
      ],
      action: 'manage'
    },
  },
] 